/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * 
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const TODIS_ISAEPORTS_SCHEMA = Yup.object().shape({
  //general section Rules:
  nameResp: Yup.string("Road ID is alphanumeric").nullable(true),
  addressResp: Yup.string("Road ID is alphanumeric").nullable(true),
  contactPer: Yup.string("Road ID is alphanumeric").nullable(true),
  contactPos: Yup.string("Road ID is alphanumeric").nullable(true),
  contactNum: Yup.string()
    .transform((originalValue) => {
      // Si el valor comienza con '+', eliminamos ese símbolo
      return typeof originalValue === 'string' ? originalValue.replace(/^\+/, '') : originalValue;
    })
    .nullable(true)
    .test('is-valid', 'Invalid data. \'Phone Number\' must be a valid number', function (value) {
      // Permitir números, espacios, y la presencia de '+'
      const isValid = /^[0-9+\s]+$/.test(value) || value === null;

      if (!isValid) {
        throw this.createError({ message: 'Invalid data. \'Phone Number\' must be a valid number' });
      }

      return true;
    }),

  contactEmail: Yup.string("Email")
    .transform((originalValue) => {
      // Realizar transformaciones si es necesario
      return typeof originalValue === 'string' ? originalValue.trim() : originalValue;
    })
    .nullable(true)
    .test('is-email', 'Invalid data. \'Email\' must be valid', function (value) {
      // Si el valor es null, lo consideramos válido y no aplicamos más validaciones
      if (value === null) {
        return true;
      }

      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      const emails = value.split(/[,;:]+/);  // Separar por comas, punto y coma, o dos puntos

      for (const email of emails) {
        if (!emailRegex.test(email.trim())) {
          throw this.createError({ message: `Invalid data. '${email}' must be a valid email address` });
        }
      }

      return true;
    }),

  countryCode: Yup.string("Country Code").nullable(true),
  tentTCategory: Yup.string("tent category is alphanumeric").nullable(true),
  nodeNameval: Yup.string("End Node Name is alphanumeric").nullable(true),
  dateValidTo: Yup.date("Valid from is a Date").required().nullable(true),
  dateValidFrom: Yup.date("Valid to is a Date").required().nullable(true),
  dateValidFor: Yup.string("Valid for is a Year"),
  remarks: Yup.string("remarks").nullable(true),

  seaportsImpPmDescDTO: Yup.object().shape({
    projectName: Yup.string('Value should be a text').nullable(true),
    typeForeseenInterven: Yup.string('Value should be a text').nullable(true),
    length: Yup.number('Value should be number').nullable(true),
    totalCostCapex: Yup.number('Value should be number').integer('Value should be an integer').nullable(true),
    estiImpDeadline: Yup.string('Value should be a text').nullable(true),
    remarks: Yup.string("remarks").nullable(true),
  }),
  seaportsImpPmEligiTentDTO: Yup.object().shape({
    railConn: Yup.boolean().nullable(true),
    roadConn: Yup.boolean().nullable(true),
    cleanFuelsAvail: Yup.boolean().nullable(true),
    terminalAvail: Yup.boolean().nullable(true),
    vtmisDeploy: Yup.boolean().nullable(true),
    iwwCemtConn: Yup.boolean().nullable(true),
    wasteFacilities: Yup.boolean().nullable(true),
    remarks: Yup.string("remarks").nullable(true),
    intermodalUnitsHandling: Yup.boolean().nullable(true),
    multimodalFreightTerminal: Yup.boolean().nullable(true),
    seaCanalsConnection: Yup.boolean().nullable(true),
    alternativeFuelsElectricity: Yup.boolean().nullable(true),
    alternativeFuelsMethane: Yup.boolean().nullable(true),
  }),
  seaportsImpPmIndicatorsDTO: Yup.object().shape({
    siAnnTraffDemGro: Yup.number('Value should be number').nullable(true),
    siModalTrans: Yup.number('Value should be number').nullable(true),
    siAnnTraffAcciRateRed: Yup.number('Value should be number').nullable(true),
    eiEirr: Yup.number('Value should be number').nullable(true),
    eiNpv: Yup.number('Value should be number').nullable(true),
    eiSdr: Yup.number('Value should be number').nullable(true),
    eiProjPlanDesCost: Yup.number('Value should be number').nullable(true),
    eiProjConstCost: Yup.number('Value should be number').nullable(true),
    eiTotalProjCost: Yup.number('Value should be number').nullable(true),
    fiFirr: Yup.number('Value should be number').nullable(true),
    fiFnpv: Yup.number('Value should be number').nullable(true),
    fiFdr: Yup.number('Value should be number').nullable(true),
    fiWacc: Yup.number('Value should be number').nullable(true),
    fiFirtsYearProf: Yup.date("Valid from is a Date").nullable(true),
    fiDscr: Yup.number('Value should be number').nullable(true),
    eniCo2Ems: Yup.number('Value should be number').nullable(true),
    eniNoxEms: Yup.number('Value should be number').nullable(true),
    eniSo2Ems: Yup.number('Value should be number').nullable(true),
    eniNmhcEms: Yup.number('Value should be number').nullable(true),
    eniPpm: Yup.number('Value should be number').nullable(true),
    eniNoiseLevel: Yup.number('Value should be number').nullable(true),
    eniCliChangeRes: Yup.number('Value should be number').nullable(true),
    eniProteNatuaAff: Yup.number('Value should be number').nullable(true),
    remarks: Yup.string("remarks").nullable(true),
  }),
  seaportsImpPmPiDTO: Yup.object().shape({
    forecastConstPeriod: Yup.number('Value should be number').nullable(true),
    actualConstPeriod: Yup.number('Value should be number').nullable(true),
    forecastCapex: Yup.number('Value should be number').nullable(true),
    actualCapex: Yup.number('Value should be number').nullable(true),
    forecastOpex: Yup.number('Value should be number').nullable(true),
    actualOpex: Yup.number('Value should be number').nullable(true),
    forecastMaintCost: Yup.number('Value should be number').nullable(true),
    actualMaintCost: Yup.number('Value should be number').nullable(true),
    interestDuringConst: Yup.number('Value should be number').nullable(true),
    ebitda: Yup.number('Value should be number').nullable(true),
    forecastRevenue: Yup.number('Value should be number').nullable(true),
    actualRevenue: Yup.number('Value should be number').nullable(true),
    forecastTrainTraffic: Yup.number('Value should be number').nullable(true),
    actualTrainTraffic: Yup.number('Value should be number').nullable(true),
    forecastPassTraffic: Yup.number('Value should be number').nullable(true),
    actualPassTraffic: Yup.number('Value should be number').nullable(true),
    forecastFreightTn: Yup.number('Value should be number').nullable(true),
    actualFreightTn: Yup.number('Value should be number').nullable(true),
    remarks: Yup.string("remarks").nullable(true)
  }),
  seaportsImpPmStatusDTO: Yup.object().shape({
    implemented: Yup.string('Value should be a text').nullable(true),
    ongoingProjFs: Yup.string('Value should be a text').nullable(true),
    matureProjFs: Yup.string('Value should be a text').nullable(true),
    projUnderPrep: Yup.string('Value should be a text').nullable(true),
    projStatusDesc: Yup.string('Value should be a text').nullable(true),
    initProjCompDate: Yup.date("Valid to is a Date").nullable(true),
    actualProjCompDate: Yup.date("Valid to is a Date").nullable(true),
    projFundNatBudg: Yup.string('Value should be a text').nullable(true),
    projFundWb: Yup.string('Value should be a text').nullable(true),
    projFundEbrd: Yup.string('Value should be a text').nullable(true),
    projFundEib: Yup.string('Value should be a text').nullable(true),
    otherIfi: Yup.string('Value should be a text').nullable(true),
    otherIfiSpec: Yup.string('Value should be a text').nullable(true),
    concessions: Yup.string('Value should be a text').nullable(true),
    concessionSpec: Yup.string('Value should be a text').nullable(true),
    euFund: Yup.string('Value should be a text').nullable(true),
    euFundSpec: Yup.string('Value should be a text').nullable(true),
    otherFund: Yup.string('Value should be a text').nullable(true),
    otherFundSpec: Yup.string('Value should be a text').nullable(true),
    projDocTitle: Yup.string('Value should be a text').nullable(true),
    projDocPrepBy: Yup.string('Value should be a text').nullable(true),
    projDocSupervBy: Yup.string('Value should be a text').nullable(true),
    remarks: Yup.string("remarks").nullable(true),
  }),
  seaportsImpPmTentcompDTO: Yup.object().shape({
    befRailConn: Yup.boolean().nullable(true),
    aftRailConn: Yup.boolean().nullable(true),
    befCmtConn: Yup.boolean().nullable(true),
    aftCmtConn: Yup.boolean().nullable(true),
    befCleanFuels: Yup.boolean().nullable(true),
    aftCleanFuels: Yup.boolean().nullable(true),
    befTerminalAvail: Yup.boolean().nullable(true),
    aftTerminalAvail: Yup.boolean().nullable(true),
    befRisDeploy: Yup.boolean().nullable(true),
    aftRisDeploy: Yup.boolean().nullable(true),
    befConnectionTwoModesTransport: Yup.boolean().nullable(true),
    aftConnectionTwoModesTransport: Yup.boolean().nullable(true),
    remarks: Yup.string("remarks").nullable(true)
  })
});

const ISAEPORTS_INIT = {
  dateValidTo: "",
  dateValidFrom: "",
  dateValidFor: "",
  tentTCategory: "",
  nodeNameval: "",
  nameResp: "",
  addressResp: "",
  contactPer: "",
  contactPos: "",
  contactNum: 0,
  contactEmail: "",
  countryCode: "",
  remarks: "",
  seaportsImpPmDescDTO: {
    projectName: "",
    typeForeseenInterven: "",
    length: 0,
    totalCostCapex: 0,
    estiImpDeadline: 0,
    remarks: ""
  },
  seaportsImpPmEligiTentDTO: {
    railConn: false,
    roadConn: false,
    cleanFuelsAvai: false,
    terminalAvai: false,
    vtmisDeploy: false,
    iwwCemtConn: false,
    wasteFacilities: false,
    remarks: "",
    intermodalUnitsHandling: false,
    multimodalFreightTerminal: false,
    seaCanalsConnection: false,
    alternativeFuelsElectricity: false,
    alternativeFuelsMethane: false,
  },
  seaportsImpPmIndicatorsDTO: {
    siAnnTraffDemGro: 0,
    siModalTrans: 0,
    siAnnTraffAcciRateRed: 0,
    eiEirr: 0,
    eiNpv: 0,
    eiSdr: 0,
    eiProjPlanDesCost: 0,
    eiProjConstCost: 0,
    eiTotalProjCost: 0,
    fiFirr: 0,
    fiFnpv: 0,
    fiFdr: 0,
    fiWacc: 0,
    fiFirtsYearProf: "",
    fiDscr: 0,
    eniCo2Ems: 0,
    eniNoxEms: 0,
    eniSo2Ems: 0,
    eniNmhcEms: 0,
    eniPpm: 0,
    eniNoiseLevel: 0,
    eniCliChangeRes: 0,
    eniProteNatuaAff: 0,
    remarks: ""
  },
  seaportsImpPmPiDTO: {
    forecastConstPeriod: 0,
    actualConstPeriod: 0,
    forecastCapex: 0,
    actualCapex: 0,
    forecastOpex: 0,
    actualOpex: 0,
    forecastMaintCost: 0,
    actualMaintCost: 0,
    interestDuringConst: 0,
    ebitda: 0,
    forecastRevenue: 0,
    actualRevenue: 0,
    forecastTrainTraffic: 0,
    actualTrainTraffic: 0,
    forecastPassTraffic: 0,
    actualPassTraffic: 0,
    forecastFreightTn: 0,
    actualFreightTn: 0,
    remarks: ""
  },
  seaportsImpPmStatusDTO: {
    implemented: "",
    ongoingProjFs: "",
    matureProjFs: "",
    projUnderPrep: "",
    projStatusDesc: "",
    initProjCompDate: "",
    actualProjCompDate: "",
    projFundNatBudg: 1,
    projFundWb: 1,
    projFundEbrd: 1,
    projFundEib: 1,
    otherIfi: 1,
    otherIfiSpec: "",
    concessions: 1,
    concessionSpec: "",
    euFund: 1,
    euFundSpec: "",
    otherFund: 1,
    otherFundSpec: "",
    projDocTitle: "",
    projDocPrepBy: "",
    projDocSupervBy: "",
    remarks: ""
  },
  seaportsImpPmTentcompDTO: {
    befRailConn: false,
    aftRailConn: false,
    befCmtConn: false,
    aftCmtConn: false,
    befCleanFuels: false,
    aftCleanFuels: false,
    befTerminalAvail: false,
    aftTerminalAvail: false,
    befRisDeploy: false,
    aftRisDeploy: false,
    befConnectionTwoModesTransport: false,
    aftConnectionTwoModesTransport: false,
    remarks: ""
  }
}

export { TODIS_ISAEPORTS_SCHEMA, ISAEPORTS_INIT };